<template>
    <div id="banner" class="out-box" :class="isbg || $route.meta.bg || menu ? 'bg2' : 'bg1'">
        <div id="tab" class="inner-box">
            <div class="logo" @click="goIndex">
                <img v-show="isbg || $route.meta.bg || menu" src="../assets/logo.png" alt="">
                <img v-show="!(isbg || $route.meta.bg || menu)" src="../assets/img/logo(2).png" alt="">
            </div>
            <div>
                <div class="tab-item">
                    <router-link to="/index">
                        <span>首页</span>
                    </router-link>
                    <div class="line"></div>
                </div>
                <div class="tab-item">
                    <router-link to="/about">
                        <span>关于我们</span>
                    </router-link>
                    <div class="line"></div>
                </div>
                <div class="tab-item">
                    <router-link to="/applicate">
                        <span>业务板块</span>
                    </router-link>
                    <div class="line"></div>
                </div>
                <div class="tab-item">
                    <router-link to="/product">
                        <span>产品中心</span>
                    </router-link>
                    <div class="line"></div>
                </div>
                <div class="tab-item">
                    <router-link to="/solve">
                        <span>解决方案</span>
                    </router-link>
                    <div class="line"></div>
                </div>
                <div class="tab-item">
                    <router-link to="/news">
                        <span>新闻资讯</span>
                    </router-link>
                    <div class="line"></div>
                </div>
                <div class="tab-item">
                    <router-link to="/case">
                        <span>精彩案例</span>
                    </router-link>
                    <div class="line"></div>
                </div>
                <div class="tab-item">
                    <router-link to="/join">
                        <span>加入我们</span>
                    </router-link>
                    <div class="line"></div>
                </div>
                <div class="phone">
                    <img v-show="isbg || $route.meta.bg" src="../assets/img/phone(2).png" style="width: 24px;">
                    <img v-show="!(isbg || $route.meta.bg)" src="../assets/img/phone(3).png" style="width: 24px;">
                    <div>{{ phone.phone1 }}</div>
                </div>
                <div v-show="!menu" @click="openMenu" class="menu">
                    <img src="../assets/img/menu.png" style="width: 24px;" alt="">
                </div>
                <div v-show="menu" @click="openMenu" class="menu">
                    <img src="../assets/img/close.png" style="width: 24px;" alt="">
                </div>
            </div>
        </div>
        <div v-show="menu" @scroll="handleScroll" class="menu-list out-box">
            <div class="inner-box" v-for="(item, index) in menuList" :key="index" @click="goPage(item.path)">
                <div class="menu-item">{{ item.name }}</div>
                <div class="menu-line"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { getPhone } from '../api/index';
export default {
    components: {
    },
    data() {
        return {
            phone: '',
            menu: false,
            menuList: [
                { name: '首页', path: '/index' },
                { name: '关于我们', path: '/about' },
                { name: '业务板块', path: '/applicate' },
                { name: '产品中心', path: '/product' },
                { name: '解决方案', path: '/solve' },
                { name: '新闻资讯', path: '/news' },
                { name: '精彩案例', path: '/case' },
                { name: '加入我们', path: '/join' },
            ],
        }
    },
    created() {
        this.getphone()
    },
    props: {
        isbg: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    methods: {
        getphone() {
            getPhone().then(res => {
                if (res.code == 0) {
                    this.phone = res.data
                }
            })

        },
        handleScroll(e) {
            e.stopPropagation()
        },
        goPage(path) {
            this.$router.push(path)
            this.openMenu()
        },
        goIndex() {
            this.$router.push('/index')
        },
        openMenu() {
            this.menu = !this.menu
            if (this.menu) {
                document.body.style.overflow = 'hidden'
            } else {
                document.body.style.overflow = 'auto'
            }
        }
    }
}
</script>

<style scoped>
#banner {
    position: fixed;
    top: 0;
    z-index: 6;
    padding: 20px 0;
}

.bg1 {
    background-color: transparent;
}

.bg2 {
    background-color: #fff;
}

#tab {
    height: 40px;
    position: relative;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

#tab>div {
    float: left;
}

.logo {
    cursor: pointer;
}

.line>img {
    width: 85px;
}

.logo+div {
    width: 75%;
    display: flex;
    justify-content: space-between;
}


.tab-item {
    margin-top: 9px;
}

.line {
    height: 2px;
    background-color: transparent;
    margin-top: 3px;
}

.bg1 .router-link-active {
    color: #fff;
    font-weight: 600;
}

.bg1 .router-link-active+.line {
    background-color: #fff;
}

.bg2 .router-link-active {
    color: #2778BF;
    font-weight: 600;
}

.bg2 .router-link-active+.line {
    background-color: #2778BF;
}

a {
    text-decoration: none;
    color: #2778BF;
    font-size: 18px;
    line-height: 25px;
    font-weight: 400;
}

.bg1 a {
    color: #fff;
}

.bg2 a {
    color: #2778BF;
}

.bg1 .phone {
    color: #fff;
}

.bg2 .phone {
    color: #2778BF;
}

.phone {
    margin-top: 8px;
    line-height: 24px;
    font-weight: 400;
    font-size: 16px;
    color: #1D1E1F;
}

.phone>img {
    float: left;
}

.phone>div {
    margin-left: 8px;
    float: left;
}

.menu {
    display: none;
}

@media screen and (max-width: 768px) {
    .tab-item {
        display: none;
    }

    .logo+div {
        width: auto;
    }

    .phone {
        display: none;
    }

    .menu {
        display: block;
        height: 30px;
        display: flex;
        align-items: center;
    }

    .menu>img {
        padding-left: 10px;
    }

    #banner {
        padding: 10px 0;
    }

    #tab {
        height: auto;
    }

    .logo>img {
        width: 60px;
    }

    .menu-list {
        display: block;
        background-color: #fff;
        height: calc(100vh - 50px);
        position: absolute;
        top: 50px;
        left: 0;
        z-index: 5;
    }

    .menu-item {
        height: 40px;
        line-height: 40px;
    }

    .menu-line {
        height: 1px;
        background-color: gray;
        width: 100%;
    }

    .menu-item>a {
        font-size: 16px;
        color: #000 !important;
    }
}
</style>